import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'teams-view';
const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const UPDATE_OFFSET = `${NAMESPACE}/UPDATE_OFFSET`;
export const TOGGLE_TEAM_SELECTION = `${NAMESPACE}/TOGGLE_TEAM_SELECTION`;
export const SET_TEAMS_SELECTION = `${NAMESPACE}/SET_TEAMS_SELECTION`;

export const INITIAL_TEAM_TABLE = createApiNamespacedConstants('initial_team_table');
export const TEAM_MOVE_USERS = createApiNamespacedConstants('team_move_users');
